module.exports = __webpack_public_path__ + "assets/vertical-card.147e1af6.svg";